const getFirstTickDistance = (containerEl: HTMLDivElement): number | null => {
  const firstTick = containerEl.querySelector('.tick');

  if (firstTick) {
    const containerRect = containerEl.getBoundingClientRect();
    const firstTickRect = firstTick.getBoundingClientRect();

    return firstTickRect.left - containerRect.left;
  }

  return null;
};

const getTickDistance = (containerEl: HTMLDivElement): number | null => {
  const ticks = containerEl.querySelectorAll('.tick');

  let maxDistance = 0;

  ticks.forEach((tick, index) => {
    if (index > 0) {
      const previousTick = ticks[index - 1];
      const distance = tick.getBoundingClientRect().x - previousTick.getBoundingClientRect().x;
      maxDistance = Math.max(maxDistance, distance);
    }
  });

  return maxDistance;
};

const getNumberOfTicks = (containerEl: HTMLDivElement): number => {
  return containerEl.querySelectorAll('.tick').length;
};

export { getFirstTickDistance, getNumberOfTicks, getTickDistance };
